function mergeMantineClassNames<T extends Record<string, string | undefined>>(
  base: Record<string, string | undefined>,
  classNames?: T,
): T {
  const keys = new Set([...Object.keys(base), ...Object.keys(classNames ?? {})]);
  const result: Record<string, string | undefined> = {};
  for (const key of keys) {
    const merged = [base[key], classNames?.[key]].filter(Boolean).join(" ");
    if (merged) {
      result[key] = merged;
    }
  }
  return result as T;
}

export { mergeMantineClassNames };
